import { createSelector } from 'reselect';
import _ from 'lodash';

export const checkoutSelector = state => state.checkout;

export const checkoutContentSelector = createSelector(
  checkoutSelector,
  checkout => _.get(checkout, 'content', '')
);

export const shoppingElementIdSelector = createSelector(
  checkoutContentSelector,
  content => _.get(content, 'shoppingElementId', '')
);

export const priceReferenceIdSelector = createSelector(
  checkoutSelector,
  content => _.get(content, 'priceReferenceId', '')
);



/** WEBPACK FOOTER **
 ** ./client/redux/modules/data/checkout/checkoutSelectors.js
 **/